import { VisitorsError } from 'components/adding-visitors-block/visitors-error.enum';
import { VisitorsValidatorResult, VisitorErrors } from '../types';
import hasDuplicates from 'utils/hasDuplicates';
import { isEmailValid } from 'utils/isEmailValid';
import { VisitorsEmailsState } from 'store/visitors-emails/types';

export default function visitorEmailsValidator(
  visitors: VisitorsEmailsState,
  hostEmail: string,
): VisitorsValidatorResult {
  if (!visitors) return { visitorErrors: {}, hasError: false, hasGenericError: false };

  const visitorErrors: VisitorErrors = {};
  const visitorEmails: string[] = [];
  let hasGenericError = false;
  let genericError: VisitorsError | undefined;

  Object.entries(visitors).forEach(([visitorId, visitor]) => {
    const visitorIdNum = parseInt(visitorId, 10);
    const fieldErrors: { [key: string]: VisitorsError } = {};

    if (!visitor.firstName || visitor.firstName.trim() === '') {
      fieldErrors.firstName = VisitorsError.EMPTY_FIRST_NAME;
    }

    if (!visitor.lastName || visitor.lastName.trim() === '') {
      fieldErrors.lastName = VisitorsError.EMPTY_LAST_NAME;
    }

    if (!visitor.email || visitor.email.trim() === '') {
      fieldErrors.email = VisitorsError.EMPTY_EMAIL;
    } else if (!isEmailValid(visitor.email)) {
      fieldErrors.email = VisitorsError.INVALID_EMAIL;
    } else {
      visitorEmails.push(visitor.email);
    }

    if (Object.keys(fieldErrors).length > 0) {
      visitorErrors[visitorIdNum] = fieldErrors;
    }
  });

  if (hasDuplicates(visitorEmails)) {
    hasGenericError = true;
    genericError = VisitorsError.DUPLICATE_EMAIL;
  }

  if (visitorEmails.includes(hostEmail)) {
    hasGenericError = true;
    genericError = VisitorsError.DUPLICATE_ORGANIZER_EMAIL;
  }

  return {
    visitorErrors,
    hasError: Object.keys(visitorErrors).length > 0 || hasGenericError,
    hasGenericError,
    genericError,
  };
}
